
import { defineComponent } from 'vue'
import moment from "moment";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name: "card-5",
    props: {
        to: {
            type: null,
            requerid: true,
            default: ''
        },
        evento: Object
    },
    setup() {
        const { t } = useI18n();
        const getDate = (date1: any, date2: any) => {
            let dat1 = moment(date1).format("DD MMM")
            let dat2 = moment(date1).format("DD/MM/YYYY") != moment(date2).format("DD/MM/YYYY") ? ' al ' + moment(date2).format('DD MMM YYYY') : ''

            return dat1 + `<span>${dat2}</span>`
        }

        return {
            t,
            getDate
        }

    },
})
